"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/* eslint-disable camelcase */
const chart_donut_pie_Height_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_donut_pie_Height"));
const chart_donut_pie_angle_Padding_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_donut_pie_angle_Padding"));
const chart_donut_pie_Padding_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_donut_pie_Padding"));
const chart_donut_pie_Width_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_donut_pie_Width"));
// Donut theme
exports.DonutTheme = {
    pie: {
        height: chart_donut_pie_Height_1.default.value,
        padding: chart_donut_pie_Padding_1.default.value,
        padAngle: chart_donut_pie_angle_Padding_1.default.value,
        width: chart_donut_pie_Width_1.default.value
    }
};
//# sourceMappingURL=donut-theme.js.map